import {
  API_ENDPOINT,
  useClientApiV2AccountsProfileQuery,
} from '../../resources/@types/accountSchema';

function useClientAccountProfileQuery(
  options?: Parameters<typeof useClientApiV2AccountsProfileQuery>[0]['options'],
) {
  return useClientApiV2AccountsProfileQuery({
    queryKey: [API_ENDPOINT.CLIENT_V2_ACCOUNTS_PROFILE],
    url: API_ENDPOINT.CLIENT_V2_ACCOUNTS_PROFILE,
    options: {
      staleTime: 1_000 * 60 * 3,
      ...options,
    },
  });
}

export const getAccountProfileQueryKey = () => [API_ENDPOINT.CLIENT_V2_ACCOUNTS_PROFILE];

export default useClientAccountProfileQuery;
